<template>
  <div class="reset-bd">
    <div class="login-header">
      <div class="left">
        <!-- <img class="logo" src="../../images/login/logo.png" alt /> -->
        <img class="name" src="../../images/login/name.png" alt />
      </div>
      <div class="right" ref="lang">
        <select-lang></select-lang>
      </div>
    </div>
    <div class="invalid-tips" v-if="invalid" @click="toLogin">{{ $t('login_reset_password.ljygqdjfhdly') }}</div>
    <div class="reset-box center" v-else>
      <div class="login-form-box" style="padding: 24px">
        <div class="title ub" style="height: 36px">
          <div class="ub-f1">
            <h1>{{ $t('login_reset_password.zhong_zhi_mi_ma') }}</h1>
          </div>
        </div>
        <div class="form-box">
          <!-- <div class="input-info">
            <span>账号名称：{{form.account}}</span>
          </div>-->
          <div class="input-info">
            <span>{{ $t('login_reset_password.yan_zheng_you_xiang') }}{{ form.email }}</span>
          </div>
          <div class="input-box">
            <input type="password" v-model="form.newPwd" :placeholder="$t('login_reset_password.mm816wbxbhszfhzmrylz')" />
          </div>
          <div class="input-box">
            <input type="password" v-model="form.confirmPwd" :placeholder="$t('login_reset_password.qzsrycxmm')" />
          </div>
          <div class="btn" @click="resetPassword" v-if="form.email">
            <span v-if="isLoading">{{ $t('login_reset_password.ti_jiao_zhong') }}</span>
            <span v-else>{{ $t('Common.com_confirm') }}</span>
          </div>
        </div>
      </div>
      <div class="img-box">
        <img src="../../images/login/reset.png" alt />
      </div>
    </div>
    <div class="login-footer ub ub-sp ub-xc">
      <div>
        <img class="logo" src="../../images/login/footer.png" alt />
      </div>
      <div class="wrap">
        <p>{{ $t('login_reset_password.dyygdkhqzychzzqjsbyy') }}</p>
        <div>
          {{ $t('login_reset_password.Copyright2023ICEbqsy') }}
          <span>{{ $t('login_reset_password.bei_an_hao') }}</span>
          <a href="http://beian.miit.gov.cn/" target="_blank">{{ $t('login_reset_password.yueICPbei15022985hao') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import selectLang from './components/select_lang.vue';

export default {
  components: { selectLang },
  data() {
    return {
      form: {
        uuid: '',
        newPwd: '',
        confirmPwd: '',
        email: '',
      },
      formValid: {
        newPwd: {
          required: true,
          min: 8,
          max: 16,
          message: this.$t('login_reset_password.mmcdbxz816wzj'),
        },
      },
      isLoading: false,
      // 是否失效
      invalid: false,
    };
  },
  mounted() {
    this.form.uuid = this.getJump('uuid');
    this.getEmail();
    this.formValid.newPwd.message = this.$t('login_reset_password.mmcdbxz816wzj');
  },
  methods: {
    getEmail() {
      this.$getJSON(`${apis.emailUuid}/${this.form.uuid}`)
        .then((res) => {
          this.form.email = res.data;
        })
        .catch((e) => {
          if (e.code && e.code === 133) {
            this.invalid = true;
          }
        });
    },
    // 重置密码
    resetPassword: async function () {
      if (this.isLoading) {
        return;
      }
      const result = await this.$validator(this.formValid, this.form);
      if (result) {
        this.$message.error(result[0].message);
        return;
      }
      if (this.form.newPwd !== this.form.confirmPwd) {
        this.$message.error(this.$t('login_reset_password.lcsrmmbyzqcxsr'));
        return;
      }
      this.isLoading = true;
      this.$postJSON(apis.PwdByEmail, Object.assign({}, this.form, { newPwd: this.encrypt(this.form.newPwd), confirmPwd: this.encrypt(this.form.confirmPwd) }))
        .then((res) => {
          this.isLoading = false;
          if (res.code === 0) {
            this.$message({
              message: this.$t('login_reset_password.zzmmcgqdl'),
              type: 'success',
            });
            this.jump('/login');
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    toLogin() {
      this.jump('/login');
    },
  },
};
</script>

<style lang="scss">
.reset-bd {
  height: 100%;
  background: rgba(40, 40, 42, 1);
  .warpper {
    width: 1280px;
    margin: 0 auto;
  }
  .reset-box {
    width: 618px;
    border-radius: 6px;
    overflow: hidden;
    background-color: #ffffff;
    display: flex;
    .login-form-box {
      flex: 1;
      padding: 24px;
    }
    .img-box {
      width: 280px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        display: inline-block;
        width: 164px;
        height: 154px;
      }
    }
    .input-info {
      height: 40px;
      line-height: 40px;
      background-color: #f5f5f5;
      padding: 0 14px;
      font-weight: bold;
      color: #757575;
      font-size: 12px;
      margin-bottom: 16px;
    }
  }

  .invalid-tips {
    text-align: center;
    text-decoration: underline;
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    transform: translate3d(0, -50%, 0);
    top: 50%;
  }
}
</style>
